// Straight-line distance between two points (Haversine), matching the
// backend's suppliers/distance.py so both sides agree on "how far".
import type { PostcodeCoordinates } from '../services/postcodes'

const EARTH_RADIUS_MILES = 3958.8

function toRadians(degrees: number): number {
  return (degrees * Math.PI) / 180
}

/** Distance in miles between two coordinate pairs. */
export function distanceInMiles(from: PostcodeCoordinates, to: PostcodeCoordinates): number {
  const dLat = toRadians(to.latitude - from.latitude)
  const dLon = toRadians(to.longitude - from.longitude)
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRadians(from.latitude)) * Math.cos(toRadians(to.latitude)) * Math.sin(dLon / 2) ** 2
  return EARTH_RADIUS_MILES * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
}
